function d(e, u) {
  return e ? e[u] || e.default || e : void 0;
}
export {
  d as getValueTransition
};
